export default "__VITE_ASSET__nittdxqo__"